import React from 'react'; // eslint-disable-line
import Tooltip from 'rc-tooltip';

const CaptionTooltip = (props) => {
    const placement = props.placement ? props.placement : 'bottom';
    return (
        <Tooltip
            placement={placement}
            trigger="[hover, focus]"
            mouseEnterDelay={0}
            mouseLeaveDelay={0.1}
            overlay={<span>{props.tooltipText}</span>}
            overlayClassName="smallTooltip"
        >
            {props.children}
        </Tooltip>
    );
};

export default CaptionTooltip;
